import { ConfigState } from 'store/config/types';
import { RootState } from 'store/reducer';
import { createSelector } from 'reselect';

export const configSelector = (state: RootState): ConfigState => state.config;

// eslint-disable-next-line max-len
export const selectLocale = createSelector(configSelector, (state) => state.locale?.toLowerCase().replace('_', '-') || 'en');
export const selectApiUrl = createSelector(configSelector, (state: RootState['config']): string => state.apiUrl);
